(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[219],{

/***/ 7891:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]",
      function () {
        return __webpack_require__(3364);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var _components_templates_main__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3193);



var DynamicMDX = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_1__["default"])(function() {
    return __webpack_require__.e(/* import() */ 524).then(__webpack_require__.bind(__webpack_require__, 8524));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8524)
            ];
        }
    }
});
var SinglePage = function(param) {
    var content = param.content;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DynamicMDX, {
        content: content
    });
};
SinglePage.getLayout = function(page) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_main__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        pageTitle: page.props.metadata.title,
        navLinks: page.props.navLinks,
        year: page.props.year,
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (SinglePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,193,888,179], function() { return __webpack_exec__(7891); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);